import Component from '../../shared/component';

export default class CommentForm extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);
    this.bindEvents();
  }

  bindEvents() {
    this.handleAJAXSuccess = this.handleAJAXSuccess.bind(this);
    this.handleAJAXError = this.handleAJAXError.bind(this);

    this.$element.on('ajax:success.CommentForm', this.handleAJAXSuccess);
    this.$element.on('ajax:error.CommentForm', this.handleAJAXError);
  }

  unbindEvents() {
    this.$element.off('ajax:success.CommentForm', this.handleAJAXSuccess);
    this.$element.off('ajax:error.CommentForm', this.handleAJAXError);
  }

  handleAJAXSuccess() {
    window.Turbolinks.reload({keepScrollPosition: true});
  }

  handleAJAXError(_, data) {
    if (data.responseJSON.throttled === true) window.Turbolinks.reload();
  }
}
